export class Programs {

    constructor() {
        this.changeHeaderDonationButtonBehaviour()
    }

    changeHeaderDonationButtonBehaviour(){
        // Change header donation button to redirect to checkout
        // with selected in page donation form with custom amount.
        // If there is no donation form, do nothing.

        const headerDonateBtn = document.querySelector(`
            .single-program header > div:first-child > div:first-child > div:nth-child(2) > div:first-child > div:last-child a
        `)
        const donationFormSubmitBtn = document.querySelector(`
            .single-program .donation_equipment_sticky_bar .add_campaign_to_cart > button.svg-at-right,
            .single-program .donation_form .donation_form_add_to_cart_button,
            .single-program .donate_without_equipment > .add_campaign_to_cart:last-child > button 
        `)

        if(
            !donationFormSubmitBtn ||
            !headerDonateBtn ||
            headerDonateBtn.innerText != 'Donate'
        ) return

        headerDonateBtn.addEventListener("click", e => {
            e.preventDefault()
            donationFormSubmitBtn.click()
        })
    }
}
